module.exports = __webpack_public_path__ + "static/media/industrial.d37406b9.jpeg";